
import { Baby } from "lucide-react";
import { DialogTitle } from "@/components/ui/dialog";
import { useTheme } from "@/lib/theme/ThemeContext";

export function AddChildDialogHeader() {
  const isLightTheme = false;

  return (
    <div className="flex items-center gap-3">
      <div className={`p-2 rounded-full ${
        isLightTheme 
          ? "bg-blue-50 text-blue-primary" 
          : "bg-slate-800 text-purple-400"
      }`}>
        <Baby className="h-5 w-5" />
      </div>
      <DialogTitle className={`text-lg font-semibold ${
        isLightTheme ? "text-slate-800" : "text-white"
      }`}>
        Add a Child
      </DialogTitle>
    </div>
  );
}
